import { IUpgradeRequestFile } from "@app/account/account.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const upgradeRequestFileAdapter: EntityAdapter<IUpgradeRequestFile> = createEntityAdapter<IUpgradeRequestFile>({
	selectId: address => address.id
});